const INFO_BANKS = [
  {
    "id": 1,
    "name": "Ngân hàng TMCP Việt Nam Thịnh Vượng (VPBank)",
    "founding_date": "1993-08-12",
    "charter_capital": 79339.0
  },
  {
    "id": 2,
    "name": "Ngân hàng TMCP Đầu tư và Phát triển Việt Nam (BIDV)",
    "founding_date": "1957-04-26",
    "charter_capital": 57004.3
  },
  {
    "id": 3,
    "name": "Ngân hàng TMCP Ngoại thương Việt Nam (Vietcombank)",
    "founding_date": "1963-04-01",
    "charter_capital": 55980.9
  },
  {
    "id": 4,
    "name": "Ngân hàng TMCP Công Thương Việt Nam (VietinBank)",
    "founding_date": "1988-03-26",
    "charter_capital": 53699.9
  },
  {
    "id": 5,
    "name": "Ngân hàng TMCP Quân Đội (MBBANK)",
    "founding_date": "1994-11-04",
    "charter_capital": 52140.0
  },
  {
    "id": 6,
    "name": "Ngân hàng TMCP Á Châu (ACB)",
    "founding_date": "1993-06-04",
    "charter_capital": 38841.0
  },
  {
    "id": 7,
    "name": "Ngân hàng Sài Gòn Hà Nội (SHB)",
    "founding_date": "1993-11-13",
    "charter_capital": 36194.0
  },
  {
    "id": 8,
    "name": "Ngân hàng TMCP Kỹ Thương Việt Nam (Techcombank)",
    "founding_date": "1993-09-27",
    "charter_capital": 35172.0
  },
  {
    "id": 9,
    "name": "Ngân hàng Nông nghiệp và Phát triển nông thôn Việt Nam (Agribank)",
    "founding_date": "1988-03-26",
    "charter_capital": 34446.86
  },
  {
    "id": 10,
    "name": "Ngân hàng TMCP Phát triển Thành phố Hồ Chí Minh (HDBank)",
    "founding_date": "1990-01-04",
    "charter_capital": 29076.0
  },
  {
    "id": 11,
    "name": "Ngân hàng Lộc Phát Việt Nam (LienVietPostBank)",
    "founding_date": "2008-03-28",
    "charter_capital": 25576.0
  },
  {
    "id": 12,
    "name": "Ngân hàng TMCP Quốc Tế Việt Nam (VIB)",
    "founding_date": "1996-09-18",
    "charter_capital": 25368.0
  },
  {
    "id": 13,
    "name": "Ngân hàng TMCP Đông Nam Á (SeABank)",
    "founding_date": "1994-03-24",
    "charter_capital": 24537.0
  },
  {
    "id": 14,
    "name": "Ngân hàng Chính sách Xã hội Việt Nam (VBSP)",
    "founding_date": "2002-10-04",
    "charter_capital": 23960.1
  },
  {
    "id": 15,
    "name": "Ngân hàng TMCP Tiên Phong (TPBank)",
    "founding_date": "2008-05-05",
    "charter_capital": 22016.0
  },
  {
    "id": 16,
    "name": "Ngân hàng TMCP Phương Đông (OCB)",
    "founding_date": "1996-06-10",
    "charter_capital": 20548.0
  },
  {
    "id": 17,
    "name": "Ngân hàng TMCP Hàng Hải Việt Nam (MSB)",
    "founding_date": "1991-07-12",
    "charter_capital": 20000.0
  },
  {
    "id": 18,
    "name": "Ngân hàng TMCP Sài Gòn Thương Tín (Sacombank)",
    "founding_date": "1991-12-21",
    "charter_capital": 18852.2
  },
  {
    "id": 19,
    "name": "Ngân hàng TMCP Xuất Nhập khẩu Việt Nam (Eximbank)",
    "founding_date": "1989-05-24",
    "charter_capital": 17470.0
  },
  {
    "id": 20,
    "name": "Ngân hàng TMCP Sài Gòn (SCB)",
    "founding_date": "2012-01-01",
    "charter_capital": 15231.7
  },
  {
    "id": 21,
    "name": "Ngân hàng Phát triển Việt Nam (VDB)",
    "founding_date": "2006-05-19",
    "charter_capital": 15085.0
  },
  {
    "id": 22,
    "name": "Ngân hàng TMCP Nam Á (Nam A Bank)",
    "founding_date": "1992-10-21",
    "charter_capital": 10580.0
  },
  {
    "id": 23,
    "name": "Ngân hàng TMCP An Bình (ABBANK)",
    "founding_date": "1993-05-13",
    "charter_capital": 10350.0
  },
  {
    "id": 24,
    "name": "Ngân hàng TMCP Đại Chúng Việt Nam (PVcomBank)",
    "founding_date": "2013-09-16",
    "charter_capital": 9000.0
  },
  {
    "id": 25,
    "name": "Ngân hàng Bắc Á (Bac A Bank)",
    "founding_date": "1994-09-01",
    "charter_capital": 8334.0
  },
  {
    "id": 26,
    "name": "Ngân hàng United Overseas Bank Việt Nam (UOB)",
    "founding_date": "2017-09-21",
    "charter_capital": 8000.0
  },
  {
    "id": 27,
    "name": "Ngân hàng TNHH MTV Woori Việt Nam (Woori)",
    "founding_date": "2016-10-31",
    "charter_capital": 7700.0
  },
  {
    "id": 28,
    "name": "Ngân hàng HSBC Việt Nam (HSBC)",
    "founding_date": "2008-09-08",
    "charter_capital": 7528.0
  },
  {
    "id": 29,
    "name": "Ngân hàng Standard Chartered Việt Nam (SCBVL)",
    "founding_date": "2008-09-08",
    "charter_capital": 6954.9
  },
  {
    "id": 30,
    "name": "Ngân hàng Public Bank Việt Nam (PBVN)",
    "founding_date": "2016-03-24",
    "charter_capital": 6000.0
  },
  {
    "id": 31,
    "name": "Ngân hàng TNHH MTV Shinhan Việt Nam (SHBVN)",
    "founding_date": "2008-12-29",
    "charter_capital": 5709.9
  },
  {
    "id": 32,
    "name": "Ngân hàng TMCP Quốc Dân (NCB)",
    "founding_date": "1995-09-18",
    "charter_capital": 5601.55
  },
  {
    "id": 33,
    "name": "Ngân hàng Việt Á (VietABank)",
    "founding_date": "2003-07-04",
    "charter_capital": 5399.6
  },
  {
    "id": 34,
    "name": "Ngân hàng Bản Việt (BVBank)",
    "founding_date": "1992-12-25",
    "charter_capital": 5017.0
  },
  {
    "id": 35,
    "name": "Ngân hàng số Vikki (Vikki Bank)",
    "founding_date": "1992-07-01",
    "charter_capital": 5000.0
  },
  {
    "id": 36,
    "name": "Ngân hàng Việt Nam Thương Tín (Vietbank)",
    "founding_date": "2007-02-02",
    "charter_capital": 4776.8
  },
  {
    "id": 37,
    "name": "Ngân hàng ANZ Việt Nam (ANZVL)",
    "founding_date": "2008-10-09",
    "charter_capital": 4511.9
  },
  {
    "id": 38,
    "name": "Ngân hàng Việt Nam hiện đại (MBV)",
    "founding_date": "1993-12-30",
    "charter_capital": 4000.1
  },
  {
    "id": 39,
    "name": "Ngân hàng CIMB (CIMB)",
    "founding_date": "2016-08-31",
    "charter_capital": 3698.2
  },
  {
    "id": 40,
    "name": "Ngân hàng TMCP Kiên Long (Kienlongbank)",
    "founding_date": "1995-10-27",
    "charter_capital": 3653.0
  },
  {
    "id": 41,
    "name": "Ngân hàng Indovina (IVB)",
    "founding_date": "1990-01-21",
    "charter_capital": 3377.5
  },
  {
    "id": 42,
    "name": "Ngân hàng TMCP Bảo Việt (BAOVIET Bank)",
    "founding_date": "2009-01-14",
    "charter_capital": 3150.0
  },
  {
    "id": 43,
    "name": "Ngân hàng Sài Gòn Công Thương (SAIGONBANK)",
    "founding_date": "1987-10-16",
    "charter_capital": 3080.0
  },
  {
    "id": 44,
    "name": "Ngân hàng Hợp tác xã Việt Nam (Co-opBank)",
    "founding_date": "2013-07-01",
    "charter_capital": 3029.63
  },
  {
    "id": 45,
    "name": "Ngân hàng Dầu khí toàn cầu (GPBank)",
    "founding_date": "1993-11-13",
    "charter_capital": 3018.0
  },
  {
    "id": 46,
    "name": "Ngân hàng Liên doanh Việt Nga (VRB)",
    "founding_date": "2006-11-19",
    "charter_capital": 3008.4
  },
  {
    "id": 47,
    "name": "Ngân hàng số Cake by VPBank (VCBNeo)",
    "founding_date": "1989-09-01",
    "charter_capital": 3000.0
  },
  {
    "id": 48,
    "name": "Ngân hàng Hong Leong Việt Nam (HLBVN)",
    "founding_date": "2008-12-29",
    "charter_capital": 3000.0
  },
  {
    "id": 49,
    "name": "Ngân hàng Thịnh Vượng và Phát triển (PGBank)",
    "founding_date": "1993-11-13",
    "charter_capital": 3000.0
  }
];

export default INFO_BANKS;
